import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'

export class ConfigParameters extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      profiles: [],
      profile: null,
      loading: true,
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
    this.handleNew = this.handleNew.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    if (this.state.companyId === 0)
      this.populateCompaniesData();
    else
      this.populateProfilesData(this.state.companyId);
  }

  selectProfile(profile) {
    this.setState(prevState => ({...prevState, profile: profile}));
  }

  handleNew() {
    this.setState(prevState => ({...prevState, profile: { id: 0 }}));
  }

  async handleSave() {
    if (!this.state.profile.name || this.state.profile.name === '')
      return;
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/profile`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.state.profile)
    });
    const data = await response.json();
    var profiles = this.state.profiles;
    for (var i = 0; i < profiles.length; i++)
    {
      if (profiles[i].id === this.state.profile?.id)
      {
        profiles[i] = this.state.profile;
        break;
      }
    }
    if (i === profiles.length)
      profiles.push(data);
    this.setState(prevState => ({...prevState, profile: data}));
    this.setState(prevState => ({...prevState, profiles: profiles}));
  }

  async handleDelete(id) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/profile/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    var profiles = this.state.profiles.filter(d => d.id !== id);
    if (this.state.profile.id === id)
      this.setState(prevState => ({...prevState, profile: null}));
    this.setState(prevState => ({...prevState, profiles: profiles}));
  }

  renderProfilesTable() {
    return (
      <><div class="tabledivbig">
        <div class="tabledivbtn">

          <table className='table table-striped' aria-labelledby="tabelLabel">
            <thead>
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Default</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {this.state.profiles.map(profile =>
                <tr key={profile.id} onClick={() => this.selectProfile(profile)} class={this.state.profile?.id === profile.id?'react-calendar__tile--active':''}>
                  <td>{profile.id}</td>
                  <td>{profile.name}</td>
                  <td>{profile.default?'+':''}</td>
                  <td><a onClick={() => this.handleDelete(profile.id)}>Delete</a></td>
                </tr>
              )}
            </tbody>
          </table>

        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" disabled={this.state.profile?.id===0} type="button" value="New" id="Button_New" onClick={this.handleNew}/>
        </div>
        {this.state.profile===null?<></>:
        <><div class="form-group">
          <label for="Input_ProfileName">Profile name</label>
          <input class="form-control" type="text" id="Input_ProfileName" name="Input.ProfileName"
            value={this.state.profile.name !== undefined ? this.state.profile.name : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, name: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceTime">Resource service time between bookings</label>
          <input class="form-control" type="text" id="Input_ServiceTime" name="Input.ServiceTime"
            value={this.state.profile.count !== undefined ? this.state.profile.count : '1'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, count: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ServiceInterval">Interval between resource service / service time</label>
          <input class="form-control" type="text" id="Input_ServiceInterval" name="Input.ServiceInterval"
            value={this.state.profile.count !== undefined ? this.state.profile.count : '1'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, count: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_OnlineReservation">Online reservation enabled yes/no</label>
          <input class="form-check-input" type="checkbox" id="Input_OnlineReservation" name="Input.OnlineReservation"
            checked={this.state.profile.admin}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, profile: {...prevState.profile, admin: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_ReadinessTime">Minimum time before reservation (time needed to get ready the resource)</label>
          <input class="form-control" type="text" id="Input_ReadinessTime" name="Input.ReadinessTime"
            value={this.state.profile.count !== undefined ? this.state.profile.count : '1'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, count: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_Delivery">Should resource be delivered</label>
          <input class="form-check-input" type="checkbox" id="Input_Delivery" name="Input.Delivery"
            checked={this.state.profile.admin}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, profile: {...prevState.profile, admin: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_MaxDeliveryDistance">Max delivery distance</label>
          <input class="form-control" type="text" id="Input_MaxDeliveryDistance" name="Input.MaxDeliveryDistance"
            value={this.state.profile.count !== undefined ? this.state.profile.count : '1'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, count: val}}));}}
          />
        </div>
        <div class="form-group">
          <label for="Input_DeliveryType">Time to deliver (based on distance or fixed)</label>
          <select class="form-control" disabled={this.state.profile.id} id="Input_DeliveryType" name="Input.DeliveryType"
            value={this.state.profile.categoryId ? this.state.profile.categoryId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, mapId: val}}));}}>
              <option value="1">Distance calc type 1</option>
              <option value="2">Distance calc type 2</option>
              <option value="3">Fixed</option>
          </select>
        </div>
        <div class="form-group">
          <label for="Input_DeliveryBillingTime">Delivery billing time</label>
          <input class="form-control" type="text" id="Input_DeliveryBillingTime" name="Input.DeliveryBillingTime"
            value={this.state.profile.count !== undefined ? this.state.profile.count : '1'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, count: val}}));}}
          />
        </div>

        <div class="form-group">
          <label for="Input_BookingAllignment">Next reservation start time (month/day/hour/half hour/15 minutes/5 minutes)</label>
          <select class="form-control" disabled={this.state.profile.id} id="Input_BookingAllignment" name="Input.BookingAllignment"
            value={this.state.profile.categoryId ? this.state.profile.categoryId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, mapId: val}}));}}>
              <option value="1">Month</option>
              <option value="2">Day</option>
              <option value="3">Hour</option>
              <option value="4">30 min</option>
              <option value="5">15 min</option>
              <option value="6">5 min</option>
          </select>
        </div>

        <div class="form-group">
          <label for="Input_ExtendTime">Possibility to extend booking (in days/hours)</label>
          <select class="form-control" disabled={this.state.profile.id} id="Input_ExtendTime" name="Input.ExtendTime"
            value={this.state.profile.categoryId ? this.state.profile.categoryId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, mapId: val}}));}}>
              <option value="1">Not possible</option>
              <option value="2">Days</option>
              <option value="3">Hours</option>
          </select>
        </div>

        <div class="form-group">
          <label for="Input_PriceInterval">Price interval (days/hours)</label>
          <select class="form-control" disabled={this.state.profile.id} id="Input_PriceInterval" name="Input.PriceInterval"
            value={this.state.profile.categoryId ? this.state.profile.categoryId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, mapId: val}}));}}>
              <option value="1">Days</option>
              <option value="2">Hours</option>
          </select>
        </div>

        <div class="form-group">
          <label for="Input_FirstPrice">First interval price</label>
          <input class="form-control" type="text" id="Input_FirstPrice" name="Input.FirstPrice"
            value={this.state.profile.price !== undefined ? this.state.profile.price : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, price: val}}));}}
          />
        </div>

        <div class="form-group">
          <label for="Input_FirstPriceHours">First interval price paid hours</label>
          <input class="form-control" type="text" id="Input_FirstPriceHours" name="Input.FirstPriceHours"
            value={this.state.profile.price !== undefined ? this.state.profile.price : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, price: val}}));}}
          />
        </div>

        <div class="form-group">
          <label for="Input_DeliveryPrice">Delivery price</label>
          <input class="form-control" type="text" id="Input_DeliveryPrice" name="Input.DeliveryPrice"
            value={this.state.profile.price !== undefined ? this.state.profile.price : '0'}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, profile: {...prevState.profile, price: val}}));}}
          />
        </div>

        <div class="tablediv">
          <input class="btn btn-primary" type="button" value={this.state.profile.id===0?"Create":"Save"} id="Button_Save" onClick={this.handleSave}/>
        </div>
        </>}
      </>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderProfilesTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="params" />
        <h4 id="tabelLabel">Booking profiles</h4>
        <p>Profiles list</p>
        {contents}
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
        this.setState(prevState => ({...prevState, companyId: this.state.companies[0].id}));
        this.populateProfilesData(this.state.companyId);
    }
  }

  async populateProfilesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/profiles`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, profiles: data, loading: false}));
  }
}
